import { all, call, put, takeLatest } from 'redux-saga/effects';
import { changeLanguage, getLanguages } from './language.actions';
import { hideLoader, showLoader } from '@topconagriculture/loader';
import { LanguageLoaders } from '../config';
import i18n from 'i18next';
import { getLanguagesRestApi } from '../api/language/language.api';
export function* getLanguagesSaga(profileRestApiInstance) {
    yield put(showLoader(LanguageLoaders.fetchLanguages));
    try {
        const result = yield call(getLanguagesRestApi, profileRestApiInstance);
        yield put(getLanguages.done({
            params: {},
            result,
        }));
    }
    catch (err) {
        console.error('An error occurred retrieving languages.');
    }
    yield put(hideLoader(LanguageLoaders.fetchLanguages));
}
export function* changeLanguageSaga(action) {
    const language = action.payload;
    if (language) {
        i18n.changeLanguage(language);
        yield put(changeLanguage.done({
            params: language,
            result: language,
        }));
    }
}
export function watchLanguageSaga(apiInstance) {
    return function* () {
        yield all([yield takeLatest(getLanguages.started, getLanguagesSaga, apiInstance.axiosProfileManager)]);
        yield all([yield takeLatest(changeLanguage.started, changeLanguageSaga)]);
    };
}
//# sourceMappingURL=language.saga.js.map